import { render, staticRenderFns } from "./u-btn-text-underline.vue?vue&type=template&id=e998606a&scoped=true&"
import script from "./u-btn-text-underline.vue?vue&type=script&lang=js&"
export * from "./u-btn-text-underline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e998606a",
  null
  
)

export default component.exports